import {omneticApi as api} from '@dms/api/base';

import {
  CreateTaskApiArg,
  CreateTaskApiResponse,
  DeleteTaskApiArg,
  DeleteTaskApiResponse,
  EditTaskApiArg,
  EditTaskApiResponse,
  GetMyTasksApiArg,
  GetMyTasksApiResponse,
  GetMyTasksCountApiArg,
  GetMyTasksCountApiResponse,
  GetTaskApiArg,
  GetTaskApiResponse,
  GetTaskCountApiArg,
  GetTaskCountApiResponse,
  GetTasksByMeApiArg,
  GetTasksByMeApiResponse,
} from './types';

export const taskManagementApi = api.injectEndpoints({
  endpoints: (build) => ({
    createTask: build.mutation<CreateTaskApiResponse, CreateTaskApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/task-management/task`,
        method: 'PUT',
        body: queryArg.createTaskRequestBody,
      }),
      invalidatesTags: (_result, _error, _queryArg) => [
        'TaskCounter',
        'TaskList',
        'BusinessCaseFutureActivity',
        'BusinessCaseActivity',
        'InterestFutureActivity',
        'InterestActivity',
        {type: 'DataGrid', id: 'task'},
      ],
    }),
    deleteTask: build.mutation<DeleteTaskApiResponse, DeleteTaskApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/task-management/task/${queryArg.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error) => [
        'TaskCounter',
        'TaskList',
        'BusinessCaseActivity',
        'InterestActivity',
        'BusinessCaseFutureActivity',
        'InterestFutureActivity',
        {type: 'DataGrid', id: 'task'},
      ],
    }),
    editTask: build.mutation<EditTaskApiResponse, EditTaskApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/task-management/task/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.editTaskRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'BusinessCaseFutureActivity',
        'InterestFutureActivity',
        'BusinessCaseActivity',
        'InterestActivity',
        'TaskCounter',
        'TaskList',
        {type: 'Task', id: queryArg.id},
        {type: 'DataGrid', id: 'task'},
      ],
    }),
    getTask: build.query<GetTaskApiResponse, GetTaskApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/task-management/task/${queryArg.id}`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'Task', id: queryArg.id}],
    }),
    getMyTasks: build.query<GetMyTasksApiResponse, GetMyTasksApiArg>({
      query: () => ({
        url: `/dms/v1/task-management/my-tasks`,
      }),
      providesTags: ['TaskList'],
    }),
    getMyTasksCount: build.query<GetMyTasksCountApiResponse, GetMyTasksCountApiArg>({
      query: () => ({
        url: `/dms/v1/task-management/my-tasks/count`,
      }),
      providesTags: ['TaskCounter'],
    }),
    getTasksByMe: build.query<GetTasksByMeApiResponse, GetTasksByMeApiArg>({
      query: () => ({
        url: `/dms/v1/task-management/tasks-by-me`,
      }),
      providesTags: ['TaskList'],
    }),
    getTaskCount: build.query<GetTaskCountApiResponse, GetTaskCountApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/task-management/task/count`,
        params: {
          state: queryArg.state,
          relatedResourceId: queryArg.relatedResourceId,
          relatedId: queryArg.relatedId,
        },
      }),
      providesTags: ['TaskCounter'],
    }),
  }),
});

export const {
  useCreateTaskMutation,
  useDeleteTaskMutation,
  useEditTaskMutation,
  useGetTaskQuery,
  useGetMyTasksQuery,
  useGetMyTasksCountQuery,
  useGetTasksByMeQuery,
  useGetTaskCountQuery,
} = taskManagementApi;
